<template>
<EmptyPane image="/document.svg" text="Select a file" />
</template>
